var _rect, _rect2, _ellipse, _ellipse2, _path, _path2, _g, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotesLegacyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 170,
    viewBox: "0 0 238 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 293.995,
    height: 152.142,
    transform: "translate(-29.3606 -0.000976562)",
    fill: "url(#paint0_linear_5503_77054)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 293.995,
    height: 152.142,
    transform: "translate(-29.3606 -0.000976562)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.1485,
    cy: 122.742,
    rx: 47.0741,
    ry: 46.6717,
    fill: "#FFF2E6",
    fillOpacity: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.561,
    cy: 52.3084,
    rx: 47.0741,
    ry: 46.6717,
    fill: "#F7FFF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.077 137.411C154.535 137.411 180.847 111.099 180.847 78.641C180.847 46.1833 154.535 19.8711 122.077 19.8711C89.6196 19.8711 63.3074 46.1833 63.3074 78.641C63.3074 111.099 89.6196 137.411 122.077 137.411Z",
    fill: "#E2F1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5503_77054",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 19,
    width: 118,
    height: 119
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.079 137.416C154.537 137.416 180.849 111.104 180.849 78.6459C180.849 46.1882 154.537 19.876 122.079 19.876C89.6214 19.876 63.3092 46.1882 63.3092 78.6459C63.3092 111.104 89.6214 137.416 122.079 137.416Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5503_77054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.829 77.5068L158.173 69.1631L140.293 51.2836L131.95 59.6273L149.829 77.5068Z",
    fill: "#FFA479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.172 69.1615L154.552 65.542L146.208 73.8857L149.828 77.5052L158.172 69.1615Z",
    fill: "#E17C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.582 73.5498L172.782 58.3496L151.106 36.6732L135.905 51.8733L157.582 73.5498Z",
    fill: "#FFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.582 73.5498L172.782 58.3496L167.264 52.8317L152.064 68.0319L157.582 73.5498Z",
    fill: "#FCC3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.823 69.73L186.173 48.3799L161.074 23.2803L139.724 44.6304L164.823 69.73Z",
    fill: "#FC4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.823 69.73L186.173 48.3799L178.944 41.1504L157.594 62.5005L164.823 69.73Z",
    fill: "#D13333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.377 63.956C162.305 62.8841 162.305 61.1463 163.377 60.0744C164.449 59.0025 166.186 59.0025 167.258 60.0744C168.33 61.1463 168.33 62.8841 167.258 63.956C166.186 65.0278 164.449 65.0278 163.377 63.956Z",
    fill: "#FFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.287 59.038C167.215 57.9661 167.215 56.2283 168.287 55.1564C169.359 54.0846 171.097 54.0846 172.169 55.1564C173.24 56.2283 173.24 57.9661 172.169 59.038C171.097 60.1099 169.359 60.1099 168.287 59.038Z",
    fill: "#FFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.346 98.2079L150.421 84.1328C152.742 81.8119 152.742 78.0489 150.421 75.7277L128.454 53.7607L110.177 72.0384L136.346 98.2079Z",
    fill: "#FFA479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.494 106.626L113.831 91.9624L133.458 72.3352L115.18 54.0576L93.2134 76.0246C90.8926 78.3455 90.8926 82.1084 93.2134 84.4296L107.289 98.5047L121.952 113.168C123.758 114.974 126.687 114.974 128.494 113.168C130.301 111.361 130.301 108.432 128.494 106.626Z",
    fill: "#FECCA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.688 59.9247L103.344 51.5811L85.4647 69.4605L93.8084 77.8042L111.688 59.9247Z",
    fill: "#FECCA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4982 73.6316L88.3959 66.5293L85.4636 69.4616L92.5659 76.564L95.4982 73.6316Z",
    fill: "#FCB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.556 95.5173L126.916 78.8773L133.458 72.335L150.098 88.975C151.905 90.7816 151.905 93.7108 150.098 95.5173C148.292 97.3239 145.362 97.3239 143.556 95.5173Z",
    fill: "#FECCA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.368 96.6062L130.641 78.8799C129.613 77.8512 127.945 77.8512 126.916 78.8799L143.556 95.52C144.858 96.8212 146.741 97.18 148.368 96.6062Z",
    fill: "#FCB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.99 104.037L120.373 85.4202L126.916 78.8779L145.532 97.4948C147.339 99.3014 147.339 102.231 145.532 104.037C143.726 105.844 140.797 105.844 138.99 104.037Z",
    fill: "#FECCA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.802 105.126L124.099 85.4228C123.071 84.3942 121.403 84.3942 120.374 85.4228L138.991 104.04C140.293 105.341 142.175 105.7 143.802 105.126Z",
    fill: "#FCB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.472 108.605L113.832 91.9652L120.374 85.4229L137.014 102.063C138.821 103.869 138.821 106.799 137.014 108.605C135.208 110.412 132.278 110.412 130.472 108.605Z",
    fill: "#FECCA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.284 109.69L117.557 91.9639C116.529 90.9352 114.861 90.9352 113.832 91.9639L130.472 108.604C131.773 109.905 133.656 110.264 135.284 109.69Z",
    fill: "#FCB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.765 114.255L91.5869 79.0771C91.2179 80.9549 91.7601 82.9758 93.2151 84.4305L107.29 98.5056L121.736 112.951C123.133 114.349 125.099 114.79 126.765 114.255Z",
    fill: "#FCB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.257 52.498L93.0566 37.2979L71.3802 58.9743L86.5804 74.1745L108.257 52.498Z",
    fill: "#CAE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.312 69.4414L76.1118 54.2412L71.3805 58.9726L86.5806 74.1728L91.312 69.4414Z",
    fill: "#8EBDE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.437 45.2554L83.0868 23.9053L57.9872 49.0049L79.3373 70.355L104.437 45.2554Z",
    fill: "#37475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7815 63.9136L64.4314 42.5635L57.9885 49.0064L79.3386 70.3566L85.7815 63.9136Z",
    fill: "#1E242A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8026 64.5175C79.7308 65.5893 77.993 65.5893 76.9211 64.5175C75.8492 63.4456 75.8492 61.7078 76.9211 60.6359C77.993 59.5641 79.7308 59.5641 80.8026 60.6359C81.8745 61.7078 81.8745 63.4456 80.8026 64.5175Z",
    fill: "#CAE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6214 59.7418C74.5496 60.8137 72.8117 60.8137 71.7402 59.7418C70.6683 58.6699 70.6683 56.9321 71.7402 55.8605C72.812 54.7887 74.5499 54.7887 75.6214 55.8605C76.6933 56.9324 76.6933 58.6702 75.6214 59.7418Z",
    fill: "#CAE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.668 60.5469L136.41 69.3917C137.47 70.0277 138.357 70.9152 138.993 71.975L147.838 86.7164L121.668 60.5469Z",
    fill: "#E17C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.629 71.5867L128.455 53.7606C124.841 50.1475 118.983 50.1475 115.37 53.7606L104.086 65.0444C102.28 66.8509 102.28 69.7801 104.086 71.5867C105.893 73.3935 108.822 73.3935 110.629 71.5867Z",
    fill: "#FFA479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.477 72.5381C107.176 73.2941 109.235 72.98 110.629 71.5866L121.669 60.5466C120.509 59.3868 118.628 59.3868 117.468 60.5466L105.477 72.5381Z",
    fill: "#E17C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0448 96.2577L105.013 90.2898C106.819 88.4832 106.819 85.5541 105.013 83.7475C103.206 81.9409 100.277 81.9409 98.4704 83.7475L92.5025 89.7154C90.6959 91.522 90.6959 94.4512 92.5025 96.2577C94.3091 98.0643 97.2382 98.0643 99.0448 96.2577Z",
    fill: "#FFA479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0452 96.2569L105.013 90.2889C106.139 89.163 106.563 87.6012 106.285 86.1465L94.2623 97.3531C95.883 97.913 97.7515 97.5509 99.0452 96.2569Z",
    fill: "#E17C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.966 103.42L112.176 96.2107C113.982 94.4041 113.982 91.475 112.176 89.6684C110.369 87.8618 107.44 87.8618 105.633 89.6684L98.4234 96.8781C96.6168 98.6847 96.6168 101.614 98.4234 103.42C100.23 105.227 103.159 105.227 104.966 103.42Z",
    fill: "#FFA479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.966 103.418L112.175 96.2081C113.341 95.0426 113.75 93.4111 113.412 91.9141L100.985 104.713C102.392 104.931 103.881 104.502 104.966 103.418Z",
    fill: "#E17C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.129 109.339L118.097 103.371C119.903 101.564 119.903 98.6351 118.097 96.8286C116.29 95.022 113.361 95.022 111.554 96.8286L105.586 102.796C103.78 104.603 103.78 107.532 105.586 109.339C107.393 111.145 110.322 111.145 112.129 109.339Z",
    fill: "#FFA479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.27 98.8154L108.091 110.625C109.516 110.864 111.03 110.437 112.13 109.338L118.098 103.37C119.331 102.137 119.721 100.381 119.27 98.8154Z",
    fill: "#E17C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.914 114.643L124.64 109.917C126.446 108.11 126.446 105.181 124.64 103.374C122.833 101.568 119.904 101.568 118.097 103.374L113.372 108.1C111.565 109.907 111.565 112.836 113.372 114.643C115.178 116.449 118.107 116.449 119.914 114.643Z",
    fill: "#FFA479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.855 105.534L115.666 115.888C117.151 116.207 118.761 115.794 119.914 114.64L124.64 109.914C125.828 108.727 126.229 107.054 125.855 105.534Z",
    fill: "#E17C60"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.55 28.7246L125.224 32.117C125.463 32.601 125.925 32.9364 126.459 33.0138L130.203 33.5579C131.548 33.7533 132.085 35.4062 131.112 36.3546L128.403 38.9953C128.016 39.3721 127.84 39.9146 127.931 40.4467L128.571 44.1751C128.8 45.5145 127.395 46.5359 126.192 45.9036L122.843 44.1433C122.366 43.8923 121.795 43.8923 121.317 44.1433L117.969 45.9036C116.766 46.5359 115.36 45.5145 115.59 44.1751L116.229 40.4467C116.32 39.9146 116.144 39.3721 115.757 38.9953L113.049 36.3546C112.076 35.4062 112.612 33.7533 113.958 33.5579L117.701 33.0138C118.235 32.9364 118.697 32.6007 118.936 32.117L120.61 28.7246C121.211 27.5059 122.949 27.5059 123.55 28.7246Z",
    fill: "#FFC432"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.57 44.1731L127.931 40.4446C127.84 39.9126 128.016 39.3701 128.403 38.9933L131.111 36.3526C132.016 35.4711 131.615 33.9831 130.474 33.6201C130.568 34.1236 130.431 34.6737 130.005 35.0886L127.297 37.7292C126.91 38.1061 126.734 38.6486 126.825 39.1806L127.464 42.909C127.694 44.2484 126.288 45.2699 125.085 44.6375L121.737 42.8772C121.259 42.6262 120.689 42.6262 120.211 42.8772L116.863 44.6375C116.437 44.8612 115.988 44.8747 115.593 44.7441C115.777 45.7785 116.945 46.4399 117.969 45.9016L121.317 44.1412C121.795 43.8902 122.365 43.8902 122.843 44.1412L126.191 45.9016C127.394 46.5339 128.8 45.5125 128.57 44.1731Z",
    fill: "#FC9815"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.584 32.5965C125.438 32.4617 125.315 32.3002 125.225 32.117L123.551 28.7246C122.949 27.5059 121.211 27.5059 120.61 28.7246L118.936 32.117C118.697 32.601 118.235 32.9364 117.701 33.0138L113.957 33.5579C112.613 33.7533 112.076 35.4062 113.049 36.3546L115.758 38.9953C115.947 39.1796 116.085 39.4036 116.166 39.6468C116.74 39.7843 117.337 39.8591 117.953 39.8591C122.046 39.8588 125.387 36.6408 125.584 32.5965Z",
    fill: "#FFD77D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5503_77054",
    x1: 146.998,
    y1: 0,
    x2: 146.998,
    y2: 152.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F8FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotesLegacyImg);
export default __webpack_public_path__ + "static/media/promotes-legacy-img.ec89f5b58125de8be3374391b2bbb718.svg";
export { ForwardRef as ReactComponent };